module.exports = __webpack_public_path__ + "img/disney.d63039b4.jpg";